import { IUserConfirmation } from './userconfirmation';
import { ReportBy } from './reportby';
import { Modification } from './modification';
import { IsharingChangeModel, SharingChangeModel } from './sharing-change-model';
import { ChangeRequestComment } from './changerequestcomment';
import { IUser } from './user';
export class ChangeRequest {
  authorityChangeRequestId?: number;
  trackAuthorityId: number;
  eic?: IUser;
  type: string;
  confirmationAction?: string;
  confirmationMessageList?: Array<IUserConfirmation>;
  reportBy?: ReportBy;
  modification?: Modification;
  authorityChangeRequestStatus?: string;
  changeUserAcceptedMessages?: Array<ChangeRequestComment>;
  changeRequestLineComment?: string;
  sharingChangeModel?: IsharingChangeModel;

  constructor(changeRequest?: ChangeRequest) {
    this.authorityChangeRequestId = (changeRequest && changeRequest.authorityChangeRequestId) || undefined;
    this.trackAuthorityId = (changeRequest && changeRequest.trackAuthorityId) || undefined;
    this.type = (changeRequest && changeRequest.type) || undefined;
    this.confirmationAction = (changeRequest && changeRequest.confirmationAction) || undefined;
    this.reportBy =
      (changeRequest && (changeRequest.reportBy === undefined ? undefined : new ReportBy(changeRequest.reportBy))) || undefined;
    this.modification =
      (changeRequest && (changeRequest.modification === undefined ? undefined : new Modification(changeRequest.modification))) || undefined;
    this.authorityChangeRequestStatus = (changeRequest && changeRequest.authorityChangeRequestStatus) || undefined;
    this.changeUserAcceptedMessages = new Array<ChangeRequestComment>();
    if (changeRequest && changeRequest.changeUserAcceptedMessages !== undefined) {
      for (let i = 0; i < changeRequest.changeUserAcceptedMessages.length; i++) {
        this.changeUserAcceptedMessages.push(new ChangeRequestComment(changeRequest.changeUserAcceptedMessages[i]));
      }
    }
    this.sharingChangeModel =
      !changeRequest || (changeRequest && !changeRequest.sharingChangeModel)
        ? undefined
        : new SharingChangeModel(changeRequest.sharingChangeModel);
    this.changeRequestLineComment = (changeRequest && changeRequest.changeRequestLineComment) || undefined;
  }
}
